import { createRoute } from "apps/visits/packages/shared/models/Route";
import { t } from "i18next";

export const routes = {
  catalog: createRoute("/"),
  thankYou: createRoute<{ uuid: string }>(`/:uuid/${t("VOUCHERS_DISTRIBUTION.ROUTES.THANK_YOU")}`),
  checkout: createRoute(`/${t("VOUCHERS_DISTRIBUTION.ROUTES.CHECKOUT")}`),
  termsAgreement: createRoute(`/${t("VOUCHERS_DISTRIBUTION.ROUTES.TERMS_AGREEMENT")}`),
};
